module.exports={name:"ニーズヘッグの塔"};